export const en = {
    'add-button-text': 'Add',
    'add-button-text-with-count': 'Add — {count}',
    'add-correction': 'New adjustment'
};
